import { NodeProps } from "react-flow-renderer/dist/nocss";

export function nodeDataIsUnchanged(prevProps: NodeProps, nextProps: NodeProps) {
  return prevProps.data === nextProps.data;
}
